export class DateTime {

  static MilliSecondsOfDay: number = 86400000;

  static ConvertToDate(milliseconds: number) : Date {
    return new Date(milliseconds);
  }

  static ConvertToDBString(JsString_YYYY_MM_DD: string): string {
    return JsString_YYYY_MM_DD + 'T00:00:00';
  }

  static ConvertToJSString(DbString: string): string {
    return '';
  }

  static GetMonthString(monthInt: number): string {
    console.log("Getmonthstring: " + monthInt);
    switch (monthInt) {
      case 0: return "Januar";
      case 1: return "Februar";
      case 2: return "März";
      case 3: return "April";
      case 4: return "Mai";
      case 5: return "Juni";
      case 6: return "Juli";
      case 7: return "August";
      case 8: return "September";
      case 9: return "Oktober";
      case 10: return "November";
      case 11: return "Dezember";
      default: return "error";
    }
  }

  /// <summery>asdfkjl sdlk</summery>
  static GetToday_YYYY_MM_DD(): string {
    let today: Date = new Date();
    let dd: string = ("0" + (today.getDate())).slice(-2);
    let mm: string = ("0" + (today.getMonth() + 1)).slice(-2);
    let yyyy: string = today.getFullYear().toString();
    yyyy + "-" + mm + "-" + dd;
    return yyyy + "-" + mm + "-" + dd;
  }

  static ConvertToString_YYYY_MM_DD(day: Date):string {
    let dd: string = ("0" + (day.getDate())).slice(-2);
    let mm: string = ("0" + (day.getMonth() + 1)).slice(-2);
    let yyyy: string = day.getFullYear().toString();
    yyyy + "-" + mm + "-" + dd;
    return yyyy + "-" + mm + "-" + dd;
  }




}



// WEBPACK FOOTER //
// ./src/app/_helpers/DateTime.ts